import { AbstractMatch } from "autolinker";

export function parseCustomMatches<T extends AbstractMatch>(regex: RegExp,
                                                            src: string,
                                                            existingMatches: AbstractMatch[],
                                                            createMatchFromRegexMatch: (match: string, index: number) => T): T[] {
  let matches: T[] = [],
    regexMatch: RegExpExecArray | null;

  const regularExpression = new RegExp(regex);
  while ((regexMatch = regularExpression.exec(src)) !== null) {
    if (!existingMatches.some(match => regexMatch.index >= match.getOffset() && regexMatch.index <= (match.getOffset() + regexMatch[0].length))) {
      matches.push(createMatchFromRegexMatch(regexMatch[0], regexMatch.index));
    }
  }
  return matches;
}